/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ last4: NonNullable<unknown> }} Ai_Key_SavedInputs */

const en_ai_key_saved = /** @type {(inputs: Ai_Key_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Saved · ends in ${i?.last4}. Type a new key to replace it.`)
};

const de_ai_key_saved = /** @type {(inputs: Ai_Key_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gespeichert · endet auf ${i?.last4}. Neuen Schlüssel eingeben, um ihn zu ersetzen.`)
};

/**
* | output |
* | --- |
* | "Saved · ends in {last4}. Type a new key to replace it." |
*
* @param {Ai_Key_SavedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ai_key_saved = /** @type {((inputs: Ai_Key_SavedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Key_SavedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ai_key_saved(inputs)
	return en_ai_key_saved(inputs)
});